import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.5px;
  margin-right: 5px;
`;
